var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHtmlLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 98,
    viewBox: "0 0 74 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_31_59)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.74341 0H13.1616V4.36508H17.2041V0H21.6222V13.2137H17.2041V8.79142H13.1616V13.2137H8.74749V0H8.74341Z",
    fill: "#8D8D8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4286 4.38142H23.5413V0H35.7382V4.38142H31.8468V13.2137H27.4286V4.38142Z",
    fill: "#8D8D8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6738 0H42.2798L45.1137 4.64275L47.9434 0H52.5494V13.2137H48.1517V6.664L45.1137 11.3639H45.0361L41.994 6.66808V13.2137H37.6738V0Z",
    fill: "#8D8D8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7461 0H59.1683V8.84858H65.375V13.2177H54.7461V0Z",
    fill: "#8D8D8D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.6045 90.1275L0.25 19.2612H73.75L65.3914 90.1193L36.9592 98.0002L8.6045 90.1275ZM25.4972 51.3358L24.7051 42.4341H57.9638L58.7397 33.7448H15.2113L17.5552 60.0292H47.6779L46.6693 71.2992L36.9755 73.9207H36.9673L27.2898 71.3074L26.6692 64.378H17.939L19.1558 78.0245L36.9592 82.9653L54.7911 78.0245L56.9634 53.6715L57.1758 51.3399H25.4972V51.3358Z",
    fill: "#F16528"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_31_59"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 98,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtmlLogo);
export default __webpack_public_path__ + "static/media/html_logo.3ee26a1efa1b32dd45e00f2516a6a618.svg";
export { ForwardRef as ReactComponent };